/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import customModal from "../customModal/customModal.vue";

export default {
  name: "CycleModal",
  components: {
    customModal,
    VPagination
  },
  emits: ["closeModal", "saved", "refreshCycleList"],
  props: {
    editingId: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      studyId: "",
      studyVersion: "",
      cycleList: [],
      cycleTypeList: [],
      armList: [],
      isEditMode: false,
      loading: false,

      newCycle: {
        cycleName: "",
        cycleId: null,
        cycleOrder: null,
        armCode: "",
        cyclePrefix:"",
        isRepeatable: false,
        minRepeats: null,
        maxRepeats: null,
        parentCycleId: null,
        cycleDuration: null,
        cycleTypeCode: "",
        cycleTypeName: ""    

      },

      errors: {
        cycleName: false,
        cycleId: false
      },
      errorMessages: {
        cycleName: "",
        cycleId: ""
      }
    };
  },
  watch: {
    editingId(newVal) {
        this.loadModalData(newVal);
    }
  },
  created() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        this.studyVersion = store.getters.getStudyVersion;
        this.loadModalData(this.editingId);
  },
  async mounted() {
    // this.token = store.getters.getIdToken;
    // this.studyId = store.getters.getStudyIs;
    // this.studyVersion = store.getters.getStudyVersion;

    console.log("CycleModal mounted, editingId:", this.editingId);

    // if (this.editingId) {
    //   this.isEditMode = true;
    //   console.log("Editing existing Cycle, ID:", this.editingId);
    //   console.log("Editing existing Cycle, isEditMode:", this.isEditMode);
    //   await this.fetchCycleById();
    // }
  },

  methods: {
    clearErrors() {
      this.errors.cycleName = false;
      this.errors.cycleId = false;
      this.errorMessages.cycleName = "";
      this.errorMessages.cycleId = "";
    },
    normalizeMinValue(field, min = 1) {
      const val = this.newCycle[field];

      if (val === "" || val == null) return;

      if (val < min) {
        this.newCycle[field] = min;
      }
    },
    validate() {
      this.clearErrors();
      let isValid = true;
      console.log("Validating newCycle:", this.newCycle);
      console.log("Validating newCycle:", this.newCycle.cycleId);
      console.log("Validating newCycle:", this.errors.cycleId);

      if (!this.newCycle.cycleName || !this.newCycle.cycleName.trim()) {
        this.errors.cycleName = true;
        this.errorMessages.cycleName =
          this.$t("navigations.please enter cycle name");
        isValid = false;
      }

      if (
        this.newCycle.cycleId === null ||
        this.newCycle.cycleId < 1
      ) {
        this.errors.cycleId = true;
        this.errorMessages.cycleId =
          this.$t("navigations.please enter valid cycle id");
        isValid = false;
      }

      if (
        this.newCycle.isRepeatable &&
        this.newCycle.minRepeats !== null &&
        this.newCycle.maxRepeats !== null &&
        this.newCycle.minRepeats > this.newCycle.maxRepeats
      ) {
        alert(
          this.$t("navigations.min repeats should be less than max repeats")
        );
        isValid = false;
      }

      return isValid;
    },
    async loadModalData(editingId) {
        if (!this.token || !this.studyId) return;

        await this.fetchCycleList();
        await this.listArms();
        await this.fetchCycleTypeList();

        if (editingId) {
        this.isEditMode = true;
        await this.fetchCycleById();
        } else {
        this.isEditMode = false;
        this.resetForm();
        }
    },
    async fetchCycleTypeList() {
        try {
            const response = await axios.get(
            `${this.baseurl}/management/cycle/listcycletypes`,
            // `https://localhost:54930/cycle/listcycletypes`,
            {
                headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
                },
            }
            );
            console.log("Fetched cycle type response:", response.data);
            this.cycleTypeList = Array.isArray(response.data)
            ? response.data
            : [];
            console.log("Fetched cycle type list:", this.cycleTypeList);
        } catch (err) {
            console.error("Failed to load cycle type list:", err);
            this.cycleTypeList = [];
        }
    },
    async listArms() {
      try {
        const currentstudy = store.getters.getStudyIs;
        this.idToken = store.getters.getIdToken;

        const response = await axios.get(`${this.baseurl}/fhir-service/arm/getarmsbystudyid?study_id=${currentstudy}`, {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json"
          }
        });
        this.armList = response.data || [];
        console.log("Fetched arms:", this.armList);
      } catch (error) {
        console.error("Error fetching arms:", error);
        this.armList = [];
      } finally {
        
      }
    },
    async fetchCycleList() {
        try {
            const response = await axios.get(
              // `https://localhost:54930/cycle/listcycles?studyId=${this.studyId}`,
            `${this.baseurl}/management/cycle/listcycles?studyId=${this.studyId}&SortProperty=cycleName&SortOrder=0`,
            {
                headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
                },
            }
            );

            this.cycleList = Array.isArray(response.data?.entities)
            ? response.data.entities
            : [];
            console.log("Fetched cycle list:", this.cycleList);

        } catch (err) {
            console.error("Failed to load cycle list:", err);
            this.cycleList = [];
        }
    },

    async fetchCycleById() {
      if (!this.editingId) return;

      try {
        this.loading = true;
        console.log("Fetching Cycle with ID:", this.editingId);

        const response = await axios.get(
          // `https://localhost:54930/cycle/getcyclebyid?id=${this.editingId}`,
          `${this.baseurl}/management/cycle/getcyclebyid?id=${this.editingId}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        const cycleData = response.data;
        console.log("Fetched CYCLEE data:", cycleData);
        if (cycleData) {
          this.newCycle = {
            cycleId:
                cycleData.cycleId !== undefined && cycleData.cycleId !== null
                    ? cycleData.cycleId
                    : null,
            cycleName: cycleData.cycleName || "",
            cycleOrder:
                cycleData.cycleOrder !== undefined && cycleData.cycleOrder !== null
                    ? cycleData.cycleOrder
                    : null,

                minRepeats:
                cycleData.minRepeats !== undefined && cycleData.minRepeats !== null
                    ? cycleData.minRepeats
                    : null,

                maxRepeats:
                cycleData.maxRepeats !== undefined && cycleData.maxRepeats !== null
                    ? cycleData.maxRepeats
                    : null,
            armCode: cycleData.armCode || "",
            cyclePrefix: cycleData.cyclePrefix || "",
            isRepeatable: cycleData.isRepeatable || false,
            cycleDuration:cycleData?.cycleDuration,
            cycleTypeCode:cycleData?.cycleTypeCode,
            cycleTypeName:cycleData?.cycleTypeName,
            parentCycleId: cycleData?.parentCycleId || null,
          };
        }
      } catch (err) {
        console.error("Error fetching Cycle data:", err);
        alert("Failed to load Cycle data for editing");
      } finally {
        this.loading = false;
      }
    },
    
    async submitCycle() {
      const isValid = this.validate();
      if (!isValid) return;
      

      
      const match = this.cycleTypeList.find(
          c => c.cycleTypeCode === this.newCycle.cycleTypeCode
        );

        this.newCycle.cycleTypeName = match ? match.cycleTypeName : "";
      if (!this.newCycle.isRepeatable) {
        this.newCycle.minRepeats = null;
        this.newCycle.maxRepeats = null;
      }

      const payload = {
        // ...(this.isEditMode && this.editingId ? { Id: this.editingId } : {}),
        CycleDefId: this.editingId,                 
        CycleId: this.newCycle.cycleId,
        StudyId: this.studyId,
        StudyVersion: this.studyVersion,

        CycleName: this.newCycle.cycleName,
        CycleOrder: this.newCycle.cycleOrder ==="" ? null : this.newCycle.cycleOrder,
        ArmCode: this.newCycle.armCode || "",
        CyclePrefix:this.newCycle.cyclePrefix|| "",
        IsRepeatable: this.newCycle.isRepeatable,
        MinRepeats: this.newCycle.minRepeats ==="" ? null : this.newCycle.minRepeats,
        MaxRepeats: this.newCycle.maxRepeats ==="" ? null : this.newCycle.maxRepeats,
        ParentCycleId: this.newCycle.parentCycleId === "null" ? null : this.newCycle.parentCycleId,
        CycleDuration: this.newCycle.cycleDuration === "" ? null : this.newCycle.cycleDuration,
        CycleTypeCode: this.newCycle.cycleTypeCode === "" ? null : this.newCycle.cycleTypeCode,
        CycleType: this.newCycle.cycleTypeName === "" ? null : this.newCycle.cycleTypeName,

        // CreatedUserId: store.getters.getUserId,
        // CreatedUserEmail: store.getters.getUserEmail,
        // CreatedAt: new Date().toISOString(),
        // LastModifiedUserId: store.getters.getUserId,
        // LastModifiedUserEmail: store.getters.getUserEmail,
        // LastModifiedAt: new Date().toISOString(),
      };

      try {
        if (this.isEditMode && this.editingId) {
          await axios.put(
            `${this.baseurl}/management/cycle/update`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.cycle updated successfully"));
        } else {
          await axios.post(
            // `https://localhost:54930/cycle/create`,
             `${this.baseurl}/management/cycle/create`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.cycle created successfully"));
        }

        this.$emit("saved");
        this.closeModal();
      } catch (err) {
        console.error("Save operation failed:", err);
        
        let backendMessage =
            err.response?.data?.messages?.[0]         
        let detailMessage = backendMessage
        ?.split("ApplicationException:")[1]  
        ?.split("\n")[0]                    
        ?.trim();
        alert(detailMessage || "Save operation failed");
      }
    },

    closeModal() {
      this.$emit("closeModal");
    },

    resetForm() {
      this.newCycle = {
        cycleName: "",
        cycleId: null,
        cycleOrder: null,
        armCode: "",
        cyclePrefix:"",
        isRepeatable: false,
        minRepeats: null,
        maxRepeats: null,
        parentCycleId: null,
        cycleDuration: null,
        cycleTypeCode: "",
        cycleTypeName: ""

      };
      this.isEditMode = false;
      this.clearErrors();
    }
  }
};
